import { Skeleton, Stack, ThemeSpaceVariable } from "@caspeco/casper-ui-library";

const MyBookingSkeleton = () => (
    <Stack
        spacing={ThemeSpaceVariable.Large}
        mt={ThemeSpaceVariable.Large}
        w="100%"
        maxW="36rem"
        mx="auto"
        px={{ base: ThemeSpaceVariable.Medium, lg: ThemeSpaceVariable.XLarge }}
    >
        <Stack spacing={ThemeSpaceVariable.Small} w="full">
            <Skeleton height="30px" w="90%" />
            <Skeleton height="22px" w="96%" />
            <Skeleton height="22px" w="84%" />
        </Stack>

        <Stack spacing={ThemeSpaceVariable.Medium} w="11rem" maxW="100%">
            <Skeleton height="22px" w="70%" />
            <Skeleton height="1px" w="100%" />
            <Skeleton height="22px" w="90%" />
            <Skeleton height="1px" w="100%" />
            <Skeleton height="22px" w="100%" />
            <Skeleton height="1px" w="100%" />
            <Skeleton height="22px" w="82%" />
            <Skeleton height="1px" w="100%" />
        </Stack>

        <Stack spacing={ThemeSpaceVariable.Small} w="full">
            <Skeleton height="22px" w="76%" />
            <Skeleton height="22px" w="36%" />
            <Skeleton height="22px" w="44%" />
        </Stack>

        <Skeleton height="56px" w="11rem" borderRadius="full" />
        <Skeleton height="56px" width="full" borderRadius={ThemeSpaceVariable.Small} />
    </Stack>
);

export default MyBookingSkeleton;
